'use client'

import { Box, Button, Flex, Text, UnstyledButton } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'
import { useTranslations } from 'next-intl'

import ResponsiveModal from '@/components/basic/ResponsiveModal'
import { OneLinkQrCode } from '@/components/OneLinkQrCode'

export default function AccessInApp() {
  const [opened, { open, close }] = useDisclosure(false)
  const t = useTranslations('accessInApp')

  return (
    <>
      <UnstyledButton
        onClick={open}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          padding: '10px 20px',
          borderRadius: 8,
          backgroundColor: 'var(--bg-button-secondary-default)',
          cursor: 'pointer',
        }}
      >
        <Text style={{ fontSize: 14, fontWeight: 600, lineHeight: '20px', color: '#92D1FF' }}>
          {t('viewAll')}
        </Text>
      </UnstyledButton>

      <ResponsiveModal
        opened={opened}
        onClose={close}
        title={t('modalTitle')}
        size={480}
        radius={40}
        withCloseButton
        fullScreen={false}
        styles={{
          header: { position: 'relative', padding: 24, gap: 12 },
          title: {
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
            pointerEvents: 'none',
            fontSize: 18,
            fontWeight: 600,
            lineHeight: '32px',
            whiteSpace: 'nowrap',
            color: 'var(--content-primary)',
          },
          body: { padding: 0 },
        }}
      >
        <Flex direction="column" gap={16} align="center" px={24} pb={0}>
          <Text
            ta="center"
            style={{
              fontSize: 14,
              fontWeight: 500,
              lineHeight: '20px',
              color: 'var(--content-secondary)',
            }}
          >
            {t('description')}
          </Text>
          <Box
            style={{
              width: 164,
              height: 164,
              borderRadius: 12,
              backgroundColor: 'white',
              boxShadow: '0px 3px 4.5px rgba(0, 0, 0, 0.18)',
              overflow: 'hidden',
              padding: 10,
              flexShrink: 0,
            }}
          >
            <OneLinkQrCode size="100%" />
          </Box>
        </Flex>
        <Box px={24} pb={24}>
          <Button radius="md" fullWidth onClick={close}>
            {t('gotIt')}
          </Button>
        </Box>
      </ResponsiveModal>
    </>
  )
}
